export enum ModuleNameEnum {
	MODULE_ACTIVITY = 'module_activity',
	MODULE_APPOINTMENT = 'module_appointment',
	MODULE_APPOINTMENT_TYPE = 'module_appointment_type',
	MODULE_DASHBOARD = 'module_dashboard',
	MODULE_DOCUMENT = 'module_document',
	MODULE_EMAIL = 'module_email',
	MODULE_IDO = 'module_ido',
	MODULE_IDO_ACTIVITY = 'module_idoactivity',
	MODULE_IDO_MAPPER = 'module_ido_mapper',
	MODULE_MAIL_DRAFTS = 'module_mail_drafts',
	MODULE_MAIL_TEMPLATES = 'module_mail_templates',
	MODULE_MESSAGE = 'module_message',
	MODULE_MY_SETTINGS = 'module_mySettings',
	MODULE_NOTE = 'module_note',
	MODULE_NOTIFICATION = 'module_notification',
	MODULE_PHONECALL = 'module_phonecall',
	MODULE_PHONECALL_OUTGOING = 'module_phonecall_outgoing',
	MODULE_QUERIES = 'module_queries',
	MODULE_SERVICE = 'module_service',
	MODULE_SIGNATURE = 'module_signature',
	MODULE_TASK = 'module_task',
	MODULE_TRASH = 'module_trash',
	MODULE_WIKI = 'module_wiki',
}
